<template>
    <div id="app" :style="{minWidth: isAuthenticated ? '0px' : 'auto'}">
        <authenticated-header v-if="!isGuestRoute || (isForcedAuthenticatedHeader && isAuthenticated)" />
        <guest-header v-else />
        <!-- <authenticated-header v-else /> -->
        <!-- <guest-header v-if="isGuestRoute || (isForcedAuthenticatedHeader && isAuthenticated)" /> -->

        <div v-if="isAuthenticated" class="bg-secondary pb-2" :style="containerStyle">
            <router-view />
        </div>
        <div v-else class="bg-secondary pb-2" :style="containerStyle">
            <router-view />
        </div>

        <authenticated-footer v-if="isAuthenticated" />
        <guest-footer v-else />

        <store-download-modal ref="downloadModal"></store-download-modal>
    </div>
</template>
<script>
import GuestHeader from "./views/guests/partials/GuestHeader";
import GuestFooter from "./views/guests/partials/GuestFooter";
import AuthenticatedHeader from "./views/partials/AuthenticatedHeader";
import AuthenticatedFooter from "./views/partials/AuthenticatedFooter";
import StoreDownloadModal from "./views/partials/StoreDownloadModal";
import store from "@store";
import { guestRoutes } from "./router/routes";

export default {
    name: "App",
    store,
    components: {
        GuestHeader, GuestFooter,
        AuthenticatedHeader, AuthenticatedFooter,
        StoreDownloadModal
    },

    computed: {
        isAuthenticated() {
            return !!this.$store.getters.tokenKey;
        },
        isForcedAuthenticatedHeader() {
            for (const matchedRoute of this.$route.matched) {
                const isForcedAuthenticated = this.forcedAuthenticatedHeaderRoutes
                    .includes(matchedRoute.name);

                if (isForcedAuthenticated) {
                    return true;
                }
            }
            return false;
        },
        containerStyle() {
            return !this.isForcedAuthenticatedHeader && this.isGuestRoute
                ? "min-height: 861px !important;"
                : "min-height: 861px !important; padding-top: 7rem";
        }

    },
    data: () => ({
        isGuestRoute: true,
        forcedAuthenticatedHeaderRoutes: [
            "Shop Page",
        ]
    }),

    methods: {
        initializeToken() {
            this.$store.dispatch("initializeToken")
                .then(response => {})
                .catch(error => {
                    console.log(error)
                });
        },
    },

    watch: {
        '$route': function(newVal) {
            for (const matchedRoute of newVal.matched) {
                this.isGuestRoute = guestRoutes
                    .map(route => route.name)
                    .includes(matchedRoute.name);

                if (this.isGuestRoute) {
                    break;
                }
            }
        }
    },

    mounted() {
        this.initializeToken();
        // this.$refs.downloadModal.show();
    }
};
</script>
